<template>
  <div id="app" :style="appTheme.styles">
      <router-view key="router-view" class="theme-go"/>
      <dean-modal key="modal"></dean-modal>
      <dean-load-overlay key="load-overlay" v-if="getLoadOverlayMethod()"></dean-load-overlay>
      <div class="ov-toaster-container">
        <b-toaster name="ov-toaster"></b-toaster>
      </div>

  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  // VUE
  import Vue from 'vue';
  import { Component, Prop, Watch } from 'vue-property-decorator';
  import { ZoomYTransition } from 'vue2-transitions';

  // DEAN COMPONENTS
  import {
    // COMPONENTS
    deanLoadOverlay,
  } from '@deanone/dean-components';
  import deanModal from './components/Modal.vue';

  @Component({
    components: {
      deanLoadOverlay,
      deanModal,
      ZoomYTransition,
    },
  })

  export default class App extends Vue {

    // COMPUTED
    get appTheme() {
      return this.$store.getters.getTheme;
    }

    get user() {
      return this.$store.getters.getUser;
    }

    // METHODS
    public getLoadOverlayMethod() {
      return this.$store.getters.getLoadOverlay;
    }
  }
</script>

<style lang="scss">
  // BARLOW
  @import url('https://fonts.googleapis.com/css?family=Barlow:200,200i,400,400i,500,500i,700,700i,900,900i&display=swap');
  @import "../node_modules/vue-select/src/scss/vue-select";
  @import "~@deanone/dean-components/src/scss/vars";
  @import "~@deanone/dean-components/src/scss/main";
  @import "~bootstrap/scss/bootstrap";
  @import "~bootstrap-vue/src/index.scss";

  #app {
    font-family: Barlow, Tahoma, Helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    overflow: hidden;
  }

  #nav {
    padding: 30px;
  }

  p {
    margin-bottom: 0;
  }

  .row {
    margin-right: 0;
    margin-left: 0;
  }

  .container, .container-fluid {
    padding-left: 0;
    padding-right: 0;
  }

  .dean-header-menu-items {
    justify-content: center;
  }

  .dean-header-mobile .dean-header-item {
    height: auto;
  }

  .barlow-extra-light {
    font-family: 'Barlow', Tahoma, Helvetica, sans-serif;
    font-weight: 200;
  }

  .barlow-extra-light-italic {
    font-family: 'Barlow', Tahoma, Helvetica, sans-serif;
    font-weight: 200;
    font-style: italic;
  }

  .barlow-regular {
    font-family: 'Barlow', Tahoma, Helvetica, sans-serif;
    font-weight: 400;
  }

  .barlow-regular-italic {
    font-family: 'Barlow', Tahoma, Helvetica, sans-serif;
    font-weight: 400;
    font-style: italic;
  }

  .barlow-medium {
    font-family: 'Barlow', Tahoma, Helvetica, sans-serif;
    font-weight: 500;
  }

  .barlow-medium-italic {
    font-family: 'Barlow', Tahoma, Helvetica, sans-serif;
    font-weight: 500;
    font-style: italic;
  }

  .barlow-bold {
    font-family: 'Barlow', Tahoma, Helvetica, sans-serif;
    font-weight: 700;
  }

  .barlow-bold-italic {
    font-family: 'Barlow', Tahoma, Helvetica, sans-serif;
    font-weight: 700;
    font-style: italic;
  }

  .barlow-black {
    font-family: 'Barlow', Tahoma, Helvetica, sans-serif;
    font-weight: 900;
  }

  .barlow-black-italic {
    font-family: 'Barlow', Tahoma, Helvetica, sans-serif;
    font-weight: 900;
    font-style: italic;
  }

  .uppercase {
    text-transform: uppercase;
  }

  .tooltip {
    position: absolute;
    padding: 0.4rem 0;
    z-index: 1070;
    display: block;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    white-space: normal;
    line-break: auto;
    font-size: 0.875rem;
    word-wrap: break-word;
  }

  .tooltip.b-tooltip {
    display: block;
    opacity: 0.9;
  }

  .tooltip-inner {
    max-width: 200px;
    padding: 0.25rem 0.5rem;
    color: #fff;
    text-align: center;
    background-color: #000;
    border-radius: 0.25rem;
  }

  .bs-tooltip-bottom .arrow {
    top: 0;
  }

  .tooltip .arrow {
    position: absolute;
    display: block;
    width: 0.8rem;
    height: 0.4rem;
    color:rgb(33, 37, 41);
    outline-color:rgb(33, 37, 41);
  }

  .bs-tooltip-bottom .arrow::before {
    bottom: 0;
    border-width: 0 0.4rem 0.4rem;
    position: absolute;
    content: "";
    border-color: transparent;
    border-style: solid;
  }

  .tooltip .arrow::before {
    bottom: 0;
    border-width: 0 0.4rem 0.4rem;
    border-bottom-color: rgb(0,0,0);
    position: absolute;
    content: "";
    border-style: solid;
    box-sizing: border-box;
  }

  .dean-sidemenu-column-item > .link:first-letter {
    text-transform: capitalize;
  }

  .ov-toaster-container {
    &, .ov-toaster {
      height: 0;
    }
    z-index: 998;
    bottom: 0;
    box-sizing: border-box;
    overflow: visible;
    position: fixed;
    left: 1rem;
    right: 1rem;
    $toast-font-size: 1rem;
    $close-font-size: $toast-font-size * 2;
    .b-toaster .b-toaster-slot {
      position: absolute;
      bottom: 1rem;
      left: 0;
      right: 0;
      margin-left: auto;
      max-width: $toast-max-width;
    }

    .toast-icon {
      padding-right: .5rem;
    }

    .b-toast {
      z-index: 999;
    }

    .b-toast-success .toast-icon {
      fill: $success;
    }
    .b-toast-danger .toast-icon {
      fill: $danger;
    }
    .b-toast-warning .toast-icon {
      fill: $warning;
    }
    .b-toast-info .toast-icon {
      fill: $info;
    }
  }
</style>
